import { Link } from "react-router-dom";
import {
  CalendarDaysIcon,
  EyeIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import moment from "moment";

const ActivityBox = ({ article }) => {
  if (!article) return null;

  const eventDate = moment(article.eventStartTime).format("DD/MM/YYYY");
  const regisStart = moment(article.regisStartTime).format("DD/MM/YYYY");
  const regisEnd = moment(article.regisEndTime).format("DD/MM/YYYY");

  return (
    <div className="bg-white shadow-md hover:shadow-lg border rounded-lg p-4 transition duration-200">
      <Link
        to={`thong-bao/${article.category?.slug}/${article.slug}`}
        className="block text-lg font-semibold text-blue-800 hover:text-blue-600 mb-2 line-clamp-2"
      >
        {article.title}
      </Link>

      <div className="text-gray-600 text-sm space-y-1 mb-3">
        <div className="flex items-center gap-2">
          <CalendarDaysIcon className="w-4 h-4 text-gray-500" />
          <span>Sự kiện: {eventDate}</span>
        </div>
        <div className="flex items-center gap-2">
          <CalendarDaysIcon className="w-4 h-4 text-gray-500" />
          <span>
            Đăng ký: {regisStart} → {regisEnd}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <UserIcon className="w-4 h-4 text-gray-500" />
          <span>Người tạo: {article.user?.userFullName || "Ẩn danh"}</span>
        </div>
        <div className="flex items-center gap-2">
          <EyeIcon className="w-4 h-4 text-gray-500" />
          <span>{article.view} lượt xem</span>
        </div>
      </div>

      <Link
        to={`thong-bao/${article.category?.slug}/${article.slug}`}
        className="inline-block mt-2 text-blue-700 font-medium hover:underline"
      >
        Xem chi tiết →
      </Link>
    </div>
  );
};

export default ActivityBox;
